import Booking from "../../Components/Booking/Booking";
import ProfileNavbar from "../../Components/ProfileNavbar/ProfileNavbar";

export default function BookingPage() {

  return (
    <>
        <ProfileNavbar/>
        <Booking/>
    </>
  );
}
